module.exports = __webpack_public_path__ + "img/logo.550330ab.svg";